import { Component, OnInit, Input } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { Router } from '@angular/router';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';
import { MenuConf } from 'src/app/beans/menu/menu-conf/menu-conf.bean';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { PasswordChangeDialg } from 'src/app/dialogs/password-change/password.change.dialog';
import { SessionKey } from 'src/app/enums/session/session-key.enum';
import { isSessionCode } from 'src/app/enums/session/session-code.enum';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';


@Component({
  selector: 'main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit 
{  
  @Input() drawer  : MatDrawer
  @Input() menuConf: MenuConf

  title: string

  titleRefresher: any

  constructor
  (
    private _handler  : HandlerManager  ,
    private _loader   : LoadingManager  ,
    private _session  : SessionManager  ,
    private _router   : Router          ,
    private _translate: TranslateService,
    private _dialog   : MatDialog       ,
  ) { }

  ngOnInit(): void 
  {
    const user = this._session.user().get() as User

    if(User.isKind(user) && user.forced == 1){ this.changePassword(1, user) }

    this.titleRefresher = setInterval(() => this.titleSetter(), 100) 
  }

  async titleSetter()
  {
    if(!this.menuConf || !this.menuConf.item) return
    try { this.title = await this._translate.get(this.menuConf.item.title).toPromise() }
    catch(error){ this.title = "" }
  }

  toggleMenu()  
  {
    this.drawer.toggle()
    
    this.menuConf.opened = this.drawer.opened

    this._session.menu().set(this.menuConf)
  }

  async logout()
  {
    const user = this._session.user().get()

    if(!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()

    await this._handler.login().logout((user as User).token)
    
    this._loader.stop()
    
    //Get organization CODE
    let code = this._session.code().get()

    console.log("code --> " + code );
    
    //Clear saved data
    localStorage.clear();

    this._router.navigate([RoutingPages.LANDING_RAW, code ])
  }

  ngOnDestroy(): void 
  {   
    if(this.titleRefresher) clearInterval(this.titleRefresher)
  }

  changePassword(forced ?: number, user?: User)
  {
    let dialog: any
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus    = true;

    if(forced) dialogConfig.data = { forced: forced }
    
    dialog = this._dialog.open(PasswordChangeDialg, dialogConfig);

    dialog.afterClosed().subscribe(async (data: any) =>
    {
      if(data.code == DialogsReturnCode.PASSWORD_CHANGE_ACCEPT)
      {
        if(user)
        {
          user.forced = 0
          this._session.user().clear()
          this._session.user().set(user)
        }
      }
    })
  }
}
